export default (chartContainer, chartSize) => {
  const ctx = document.getElementById(chartContainer).getContext('2d');

  if (chartSize?.height) {
    ctx.canvas.parentNode.style.height = chartSize.height;
  }

  return ctx;
};
